export default __webpack_public_path__ + "static/media/ic_hop.0f4a98a0.svg";